<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component class="kendo-pointer-default"
        v-model="selected"
        value-key="IdCIFEmpresa"
        :id-vista="idVista"
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        :selectedField="selectedField"
        @datastatechange="dataStateChange">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="primary" :text="labelBtnExcel" icon="excelxls" @click="exportExcel" 
            :loading="isGeneralLoading || loadingExcel" :disabled="loadingExcel"/>
          <base-button-responsive mode="primary" :text="$t('companies.link_company')" icon="plus" @click="golinkCompany" 
            :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <base-button-item-list theme="dark" @click="unlink">
            <base-icon name="unlink" class="mr-2" />
              {{$t('app.unlink_entity')}}
          </base-button-item-list>
        </template>
      </base-table-select-actions-expand>
      <group-link-company-dialog 
        :dialogOpen="linkCompany" 
        :groupId="$route.params.id" 
        @toggleDialog="toggleDialogs" 
        @applyDialog="applyLinkHandler"
        />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog
        :numberSearches="numberSearches"
        :idVista="idVista"
        :dialogOpen="saveSearchDialog"
        :tags="tags"
        @toggleDialog="toggleDialogSearches"
        @applyDialog="applySearchHandler" />
      <filter-panel-searches
        ref="filterPanelSearches"
        :idVista="idVista"
        :vuexnamespace="vuexnamespace"
        :panelOpen="searchesPanel"
        @togglePanel="toggleSearchesDialog"
        @applyFilters="applyFiltersHandler"
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/GroupCompaniesFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { i18n } from '@/i18n'
// import moment from 'moment'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import GroupLinkCompanyDialog from '@/components/GroupLinkCompanyDialog.vue'

import { getGroup } from '@/services/configurations/groups/getGroup'
import { getCompanies } from '@/services/configurations/groups/getCompanies'
import { linkGroupCompanies } from '@/services/configurations/groups/linkGroupCompanies'
import { unlinkGroupCompanies } from '@/services/configurations/groups/unlinkGroupCompanies'
import { getGroupEmpresasExcel } from '@/services/configurations/groups/getGroupEmpresasExcel'

export default {
  name: 'companies-by-group',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    GroupLinkCompanyDialog,
  },
  data: function () {
    return {
      idVista: 47,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      showModal: false,
      linkCompany: false,
      spanish: true,
      header: {
        title: i18n.t('companies.companies_link'),
        icon: 'config',
        breadcrumb: null,
        url: 'configurations/groups/details'
      },
      vuexnamespace: 'groupcompanies',
      selectedField: 'selected',
      filterPanel: false,
      loadingDataTable: false,
      data: null,
      selected: [],
    }
  },
  computed: {
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    }
  },
  mounted: async function () {
    const groupId = this.$route.params.id
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    const breadcrumbs = []
    if ((this.role === 7 || this.role === 8 || this.role === 3)) {
      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: i18n.t('configurations.header')
      })
    }
    breadcrumbs.push({ path: 'configurations/groups', name: i18n.t('groups.header') })

    const group = await this.downloadData(groupId)
    breadcrumbs.push({ path: '', name: group.Nombre })
    this.$store.commit('app/setheaderBreadCrumb', group.Nombre)
    this.disableRoutes(group)

    this.header.breadcrumb = breadcrumbs

    this.data = await this.applyFilters()
  },
  methods: {
    disableRoutes: function (grupo) {
      const objDisableRoutes = {
        disableUsers: grupo.idTipo === 3,
        disableStatuses: grupo.idTipo === 1 || grupo.idTipo === 3 || grupo.VerTodoEstados,
        disableCompanies: grupo.idTipo === 1 || grupo.idTipo === 3 || grupo.VerTodoEmpresas,
      }
      bus.$emit('disableOptionsGroup', objDisableRoutes)
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.linkCompany = !this.linkCompany
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idGrupo: this.$route.params.id,
        CIF: data.cif ? data.cif.value : null,
        nombre: data.name ? data.name.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        estado: data.estado ? data.estado.value : null,
        email: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (data.ActiveReports) {
        payload.ActiveReports = data.ActiveReports.value
      }
      if (this.hasSelected) {
        payload.listaIDs = this.selected
      }
      try {
        const response = await getGroupEmpresasExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'grupo-empresas.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idGrupo: this.$route.params.id,
        CIF: data.cif ? data.cif.value : null,
        nombre: data.name ? data.name.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        estado: data.estado ? data.estado.value : null,
        email: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      if (data.ActiveReports) {
        objOrder.ActiveReports = data.ActiveReports.value
      }
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getCompanies(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      data.respuesta.forEach(o => {
        o.DiasDescargaAutomatica = o.DiasDescargaAutomatica === null ? 0 : o.DiasDescargaAutomatica
        o.DiasAviso = o.DiasAviso === null ? 0 : o.DiasAviso
        o.DiasFinTramite = o.DiasFinTramite === null ? 0 : o.DiasFinTramite
      })
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    downloadData: async function (id) {
      let grupo = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          idGrupo: id
        }
        grupo = await getGroup(params)
        if (grupo.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', grupo))
        } else {
          grupo = grupo.Respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return grupo
    },
    unselect: function () {
      this.selected = []
    },
    unlink: async function () {
      const selected = this.selected
      await this.unlinkHandler(selected)
      this.data = await this.applyFilters()
    },
    unlinkHandler: async function (companies) {
      try {
        this.$store.commit('setIsLoading', true)
        const idGrupo = this.$route.params.id
        const payload = { idGrupo: idGrupo, idCifs: companies }
        const response = await unlinkGroupCompanies(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.unselect()
          this.doFeedback(i18n.t('feedback.success.entity_unlinked_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    golinkCompany: function () {
      this.linkCompany = !this.linkCompany
    },
    applyLinkHandler: async function (companies) {
      this.linkCompany = false
      await this.linkHandler(companies)
      this.applyFilters()
    },
    linkHandler: async function (companies) {
      try {
        this.$store.commit('setIsLoading', true)
        const idGrupo = this.$route.params.id
        const payload = { idGrupo: idGrupo, idCifs: companies }
        const response = await linkGroupCompanies(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
